const sortPostsByDate = posts => {
  return (
    posts &&
    posts.sort((a, b) => {
      return new Date(b.publishedDate || b.createdAt) - new Date(a.publishedDate || a.createdAt);
    })
  );
};

module.exports = { sortPostsByDate };
